import script from "./add.vue?vue&type=script&setup=true&lang=js"
export * from "./add.vue?vue&type=script&setup=true&lang=js"

import "./add.vue?vue&type=style&index=0&id=1d62341d&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d62341d"]])

export default __exports__